var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticStyle:{"padding-right":"360px"}},[_c('phone-ctn',[_c('modeselect-bar')],1)],1),_c('config-ctn',{attrs:{"title":"约课模式选择页面"}},[_c('div',{staticClass:"p10"},[_c('label',{staticClass:"f12"},[_vm._v("目前此页面直接跳转客多赞马术系统,不需要配置")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }